import { defineComponent as _defineComponent } from 'vue'
import {
  MAX_SKILLS,
  MAX_SKILL_LENGTH,
  useEnglishResumeFormatData,
  useEnglishResumeHistoriesApi
} from '@/composables/format-edit/useEnglishResumeFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumeSkillsCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useEnglishResumeFormatData()
const { addSkill, deleteSkill, moveSkill } = useEnglishResumeHistoriesApi()

return { __sfc: true,formatData, addSkill, deleteSkill, moveSkill, MAX_SKILLS, MAX_SKILL_LENGTH }
}

})